'use strict';

var Field = require('./Field');

angular.module('dekky.forms.fields.textarea', [])
	.factory('TextareaField', function() {
		function textareaFactory(name, options) {
			function Textarea(name, options) {
				this.type = 'textarea';

				Field.apply(this, arguments);
			}

			Textarea.prototype = Object.create(Field.prototype);

			return new Textarea(name, options);
		}

		return textareaFactory;
	});